import * as React from "react";
import { ScrollableList, IListItemDetails, ListSelection, ListItem } from "azure-devops-ui/List";
import { ArrayItemProvider } from "azure-devops-ui/Utilities/Provider";
import { Icon, IconSize } from "azure-devops-ui/Icon";
import { Card } from "azure-devops-ui/Card";
import { ITaskItem, tasks } from "./Data";

import "./List.Example.css";

export default class ScrollableListExample extends React.Component {
    private selection = new ListSelection(true);
    private tasks = new ArrayItemProvider(tasks);

    public render(): JSX.Element {
        return (
            <Card>
                <div style={{ display: "flex", height: "300px" }}>
                    <ScrollableList
                        itemProvider={this.tasks}
                        renderRow={this.renderRow}
                        selection={this.selection}
                        width="100%"
                    />
                </div>
            </Card>
        );
    }

    private renderRow = (
        index: number,
        item: ITaskItem,
        details: IListItemDetails<ITaskItem>,
        key?: string
    ): JSX.Element => {
        return (
            <ListItem key={key || "list-item" + index} index={index} details={details}>
                <div className="list-example-row flex-row h-scroll-hidden">
                    <Icon iconName={item.iconName} size={IconSize.medium} />
                    <div
                        style={{ marginLeft: "10px", padding: "10px 0px" }}
                        className="flex-column h-scroll-hidden"
                    >
                        <span className="wrap-text">{item.name}</span>
                        <span className="fontSizeMS font-size-ms secondary-text wrap-text">
                            {item.description}
                        </span>
                    </div>
                </div>
            </ListItem>
        );
    };
}
